import axiosService from './axiosService';

const formatData = (data, passwordObj) => {
  const { userRoles, ...userData } = data;
  return {
    user: userData,
    roles: userRoles,
    ...(passwordObj?.passwordOne && { password: passwordObj.passwordOne })
  };
};

class UserService {
  allUsers = () => axiosService.get('/api/users');

  getUser = (userId) => axiosService.get(`/api/users/${userId}`);

  getUserRoles = (userId) => axiosService.get(`/api/users/${userId}/roles`);

  createUser = (data, passwordObj) => axiosService.post('/api/users', formatData(data, passwordObj));

  updateUser = (data, passwordObj) => axiosService.put(`/api/users/${data.id}`, formatData(data, passwordObj));

  updateUserRoles = (data, userId) => axiosService.put(`/api/users/${userId}`, data);

  deleteUser = (userId) => axiosService.delete(`/api/users/${userId}`);

  getUserOptions = (userId) => axiosService.get(`/api/users/${userId}/options`);
}

const userService = new UserService();
export default userService;
